import styled from 'styled-components';

export const BookStyled = styled.a<{ color?: string; hoverColor?: string; textColor?: string }>`
  background-color: ${(props) => props?.color && `${props.color}!important`};
  color: ${(props) => props?.textColor && `${props.textColor}!important`};
  &:hover {
    background-color: ${(props) => (props?.hoverColor ? `${props.hoverColor}!important` : 'var(--color-secondary)!important')};
  }
`;

export const SearchSpanStyled = styled.span<{ color?: string }>`
  background: ${(props) => props?.color && `${props.color}!important`};
`;

export const NavStyled = styled.nav<{ menuBgColor?: string }>`
  background: ${(props) => (props?.menuBgColor ? `${props?.menuBgColor} !important` : '')};
  &.insideEcommerce {
    top: 85px !important;
    border-radius: 8px !important;
  }
  &.openWithSidebar {
    right: 50px !important;
  }
  &.openWithSidebarMax {
    right: 180px !important;
  }
`;

export const DivStyled = styled.div<{ color?: string; hoverColor?: string; textColor?: string }>`
  background-color: ${(props) => props?.color && `${props.color}!important`};
  color: ${(props) => props?.textColor && `${props.textColor}!important`};
  &:hover {
    background-color: ${(props) => (props?.hoverColor ? `${props.hoverColor}!important` : 'var(--color-secondary)!important')};
  }
`;
